import React, { useState } from "react";
import { uploadToS3 } from "@/lib/api";
import { Upload, X, Loader2 } from "lucide-react";

export default function MultiMediaUploader({
  items = [], onChange,
  resourceType = "image",
  folder = "uploads",
  weddingSlug, purpose, association,
  testId,
}) {
  const [busy, setBusy] = useState(false);
  const [progress, setProgress] = useState({ done: 0, total: 0 });
  const [err, setErr] = useState("");

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true); setErr("");
    setProgress({ done: 0, total: files.length });
    const uploaded = [...items];
    for (let i = 0; i < files.length; i++) {
      try {
        const m = await uploadToS3(files[i], resourceType, { folder, weddingSlug, purpose, association });
        uploaded.push({ url: m.url, public_id: m.storage_key, storage_key: m.storage_key, media_id: m.id, type: resourceType });
      } catch (e2) {
        setErr(`${files[i].name}: ${e2.message}`);
        break;
      }
      setProgress({ done: i + 1, total: files.length });
    }
    onChange(uploaded);
    setBusy(false);
    setProgress({ done: 0, total: 0 });
    e.target.value = "";
  };

  const addUrl = () => {
    const url = window.prompt("Paste media URL");
    if (url) onChange([...items, { url, public_id: null, type: resourceType }]);
  };

  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));

  return (
    <div>
      <div className="flex items-center gap-3 mb-3">
        <label data-testid={testId} className="btn-pill btn-outline cursor-pointer !py-2 !px-4 text-[10px]">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
          {busy && progress.total > 0 ? `Uploading ${progress.done}/${progress.total}` : `Upload ${resourceType}s`}
          <input type="file" multiple className="hidden" accept={resourceType === "video" ? "video/*" : "image/*"} onChange={handleFiles} />
        </label>
        <button type="button" onClick={addUrl} className="eyebrow link-underline">+ Add URL</button>
        <span className="text-xs text-[color:var(--text-muted)]">{items.length} items</span>
      </div>
      {err && <div className="text-red-400 text-xs mb-2">{err}</div>}
      {items.length > 0 && (
        <div className="grid grid-cols-4 md:grid-cols-6 gap-2">
          {items.map((it, i) => (
            <div key={i} className="relative aspect-square bg-[color:var(--surface)]">
              {resourceType === "image" ? (
                <img src={it.url} alt="" className="w-full h-full object-cover" loading="lazy" />
              ) : (
                <video src={it.url} className="w-full h-full object-cover" muted preload="metadata" />
              )}
              <button type="button" onClick={() => remove(i)} className="absolute top-1 right-1 w-6 h-6 rounded-full bg-black/70 flex items-center justify-center hover:bg-red-500">
                <X size={12} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
